import React from "react";
// Mui
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Checkbox from "@mui/material/Checkbox";

export default function CheckboxBasic({
  label,
  checked,
  onChange,
  error,
  required,
  type,
  ...otherProps
}) {
  const formLabelProps = {
    required: required,
    sx: {
      ...otherProps.sx,
      marginBottom: -1,
      fontSize: 18,
      fontWeight: "700",
    },
  };

  const configHelperText = {
    sx: { color: "red", fontSize: 15 },
    ...otherProps.sx,
  };

  return (
    <React.Fragment>
      <Box sx={{ display: "flex" }}>
        <FormControl
          error={error}
          //   component='fieldset'
          variant='standard'
        >
          <FormLabel component='legend' {...formLabelProps}>
            {}
          </FormLabel>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={checked} onChange={onChange} />}
              label={label}
            />
          </FormGroup>

          <FormHelperText {...configHelperText}>
            {otherProps.errorMessage}
          </FormHelperText>
        </FormControl>
      </Box>
    </React.Fragment>
  );
}
